var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", [
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "app-training",
            label: _vm.t("app-training"),
            options: _vm.yesOrNoOptions,
            required: "true",
          },
          on: {
            input: function ($event) {
              return _vm.onChange()
            },
          },
          model: {
            value: _vm.program.attributes.field_ns_training,
            callback: function ($$v) {
              _vm.$set(_vm.program.attributes, "field_ns_training", $$v)
            },
            expression: "program.attributes.field_ns_training",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.field_ns_training === "app-yes"
      ? _c(
          "div",
          { staticClass: "ui-form-row col-2 multilang" },
          _vm._l(_vm.languages, function (language, i) {
            return _c("app-textarea", {
              key: `program-mentor-training-${language.langcode}`,
              attrs: {
                label: _vm.t("app-program-mentor-training"),
                "label-lang": language.langcode,
                required: language.langcode === _vm.currentLanguage,
                id: `program-mentor-training-${language.langcode}`,
                minlength: "30",
              },
              model: {
                value:
                  _vm.program.localizedAttributes[language.langcode]
                    .field_ns_training_description,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.localizedAttributes[language.langcode],
                    "field_ns_training_description",
                    $$v
                  )
                },
                expression:
                  "program.localizedAttributes[language.langcode].field_ns_training_description",
              },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }